var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoAzulMoradia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.001,
    height: 72.001,
    viewBox: "0 0 72.001 72.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16955",
    "data-name": "Grupo 16955",
    transform: "translate(0 -5466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclus\\xE3o_1",
    "data-name": "Exclus\\xE3o 1",
    d: "M14166,2685a35.9,35.9,0,1,1,14.012-2.829A35.766,35.766,0,0,1,14166,2685Zm-13.736-38.166a.891.891,0,0,0-.892.888v16.919a3.565,3.565,0,0,0,3.561,3.561h19.59a3.565,3.565,0,0,0,3.561-3.561v-16.919a.89.89,0,0,0-1.779,0v16.919a1.783,1.783,0,0,1-1.781,1.782h-5.343v-11.577a.893.893,0,0,0-.892-.891h-7.121a.893.893,0,0,0-.892.891v11.577h-5.343a1.783,1.783,0,0,1-1.781-1.782v-16.919A.889.889,0,0,0,14152.263,2646.835Zm12.464-15.69h0l5.541,5.542a.889.889,0,0,0,.153.153l3.408,3.407a1,1,0,0,0,.152.153l7.959,7.959a.87.87,0,0,0,1.23-1.23l-7.76-7.759V2631.7a.888.888,0,0,0-.891-.891h-3.562a.892.892,0,0,0-.891.891v2.331l-4.623-4.623c-.011-.016-.02-.031-.028-.047a.382.382,0,0,0-.054-.081.87.87,0,0,0-.61-.25h-.055a.86.86,0,0,0-.61.25.486.486,0,0,0-.066.1l-.016.027-17.726,17.725a.87.87,0,0,0,1.23,1.23l17.214-17.215Zm2.67,35.275h-5.343v-10.682h5.343v10.681Zm6.233-28.831,0,0-1.78-1.78v-3.222h1.782v5Z",
    transform: "translate(-14130 2853)",
    fill: "#4663ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Elipse_2_-_Contorno",
    "data-name": "Elipse 2 - Contorno",
    d: "M36,2A34.009,34.009,0,0,0,22.766,67.329,34.009,34.009,0,0,0,49.234,4.671,33.785,33.785,0,0,0,36,2m0-2A36,36,0,1,1,0,36,36,36,0,0,1,36,0Z",
    transform: "translate(0 5466)",
    fill: "#4663ab"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAzulMoradia);
export default __webpack_public_path__ + "static/media/ico-azul-moradia.cd478ddc6f8b6f4dfdd658fca6418c00.svg";
export { ForwardRef as ReactComponent };